import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M28.3333 12.2C25.2533 7.36 20.7467 4.57333 16 4.57333C13.6267 4.57333 11.32 5.26667 9.21333 6.56C7.10667 7.86667 5.21333 9.77333 3.66667 12.2C2.33333 14.2933 2.33333 17.6933 3.66667 19.7867C6.74667 24.64 11.2533 27.4133 16 27.4133C18.3733 27.4133 20.68 26.72 22.7867 25.4267C24.8933 24.12 26.7867 22.2133 28.3333 19.7867C29.6667 17.7067 29.6667 14.2933 28.3333 12.2ZM16 21.3867C13.0133 21.3867 10.6133 18.9733 10.6133 16C10.6133 13.0267 13.0133 10.6133 16 10.6133C18.9867 10.6133 21.3867 13.0267 21.3867 16C21.3867 18.9733 18.9867 21.3867 16 21.3867Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 12.1867C13.9067 12.1867 12.2 13.8933 12.2 16C12.2 18.0933 13.9067 19.8 16 19.8C18.0933 19.8 19.8133 18.0933 19.8133 16C19.8133 13.9067 18.0933 12.1867 16 12.1867Z",
  fill: "#697B8E",
  "fill-opacity": "0.57"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M27 9L16 16.25L5 23.5",
  stroke: "black",
  "stroke-opacity": "0.69",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoShowIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})